// extracted by mini-css-extract-plugin
export default {"container":"FAQs_container__-t6Fo","dark":"FAQs_dark__MGCBh","questions":"FAQs_questions__SCgHW"};